"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeNonce = exports.validateNonce = exports.storeNonce = void 0;

var consts = _interopRequireWildcard(require("./constants"));

/* global sessionStorage */

/**
 * Generate a random string using window.crypto
 * See https://auth0.com/docs/api-auth/tutorials/nonce
 * @param {number} length - the length of the string
 * @return {string} - the random string
 */
var randomString = function randomString(length) {
  var bytes = new Uint8Array(length);
  var random = window.crypto.getRandomValues(bytes);
  var result = [];
  var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
  random.forEach(function (c) {
    result.push(charset[c % charset.length]);
  });
  return result.join('');
};
/**
 * store the nonce in the browser
 *
 * @param {string} nonce - the nonce to store
 * @returns {void} - nothing
 */


var storeNonce = function storeNonce(nonce) {
  sessionStorage.setItem(consts.MID_NONCE, nonce);
};
/**
 * validate the provided nonce against the one stored in the browser
 *
 * @param {string} nonce - the nonce to check
 * @return {boolean} - was the nonce the same?
 */


exports.storeNonce = storeNonce;

var validateNonce = function validateNonce(nonce) {
  var previousNonce = sessionStorage.getItem(consts.MID_NONCE); // nonce must be truthy as well as equivalent to the stored nonce

  return !!nonce && nonce === previousNonce;
};
/**
 * Creates a new cryptographically sound nonce
 * @return {string} - a nonce
 */


exports.validateNonce = validateNonce;

var makeNonce = function makeNonce() {
  return randomString(32);
};

exports.makeNonce = makeNonce;